import React, { useContext, useState, useEffect } from "react";
import { MdDirectionsCar } from "react-icons/md";
import { addDoc, collection, Timestamp, updateDoc, doc, onSnapshot } from "firebase/firestore";
import {
  useHistory,
} from "react-router-dom";

import LoadableButton from '../components/LoadableButton'
import {FirebaseContext} from '../services/Firebase/Context'
import {AuthContext} from '../services/Session/Context'

const HistoryForm = ({ id }) => {
  const { db } = useContext(FirebaseContext)
  const { user } = useContext(AuthContext)
  const [step, setStep] = useState({})
  const [closed, setClosed] = useState(false)
  const [loading, setLoading] = useState(false)
  const [record, setRecord] = useState({})
  const history = useHistory();

  useEffect(() => {
    if(!id) return
    const unsubscribe = onSnapshot(doc(db, "records", id), (doc) => {
      setRecord({id: doc.id, ...doc.data()})
    });
    return () => unsubscribe()
  }, [db, id])


  const handleSave = (e) => {
    e.preventDefault()
    if(!step.title) return
    setLoading(true)
    addDoc(collection(db, "steps"), {
      date: Timestamp.fromDate(new Date()),
      userId: user.uid,
      organisationId: user.organisationId,
      title: step.title,
      recordId: id,
      desc: step.desc || '',
      ended: closed
    })
    .then((docRef) => { 
      if(!closed) {
        updateDoc(doc(db, "records", id), {
          status: 'pending',
          pendingAt: Timestamp.fromDate(new Date()),
          pendingBy: user.uid,
        })
        .then(() => {
          addDoc(collection(db, "notifications"), {
            action: "new",
            createdAt: Timestamp.fromDate(new Date()),
            userId: user.uid,
            organisationId: user.organisationId,
            type: 'step',
            recordId: id,
            stepId: docRef.id
          })
          .then(() => {
            setLoading(false)
            history.push('/app/interventions')
          })
          .catch(() => { 
            setLoading(false)
          })
        })
        .catch(() => { 
          setLoading(false)
        })
        return
      }
      updateDoc(doc(db, "records", id), {
        status: 'ended',
        endedAt: Timestamp.fromDate(new Date()),
        endedBy: user.uid,
      })
      .then(() => {
        addDoc(collection(db, "notifications"), {
          action: "end",
          createdAt: Timestamp.fromDate(new Date()),
          userId: user.uid,
          organisationId: user.organisationId,
          type: 'record',
          recordId: id
        })
        .then(() => {
          setLoading(false)
          history.push('/app/interventions')
        })
        .catch(() => { 
          setLoading(false)
        })
      })
      .catch(() => { 
        setLoading(false)
      })
      if (record && record.customerPhone) {
        // use base64 -> organisationId  ..  recordId (.. is the separator)
        const encrypted = Buffer.from(user.organisationId + ".." + id).toString('base64');
        window.location = `sms:${record.customerPhone};?&body=Cher(e) client(e),%0DVotre véhicule est disponible. Nous vous invitons à venir le récupérer. N'oubliez pas de nous laisser votre avis en cliquant sur ce lien : ${window.location.origin}/feedbacks/${encrypted}%0DCordialement,%0D${user.organisation.name}`
      }
    })
    .catch(() => { 
      setLoading(false)
    })
  }

  return (
    <form className="shadow-md">
      <div className="p-4 bg-gray-100 border-t-2 border-blue-400 rounded-lg bg-opacity-5">
        <div className="max-w-sm mx-auto md:w-full md:mx-0">
          <div className="inline-flex items-center space-x-4">
            <MdDirectionsCar className="bg-blue-200 rounded-full h-10 w-10 p-2" color="white" />
            <h1 className="text-gray-600">
              Mise à jour du dossier
            </h1>
          </div>
        </div>
      </div>
      <div className="space-y-6 bg-white">
        <div className="items-center w-full p-4 space-y-4 text-gray-500 md:inline-flex md:space-y-0">
          <div className="max-w-sm mx-auto space-y-5 md:w-2/3">
            <div>
              <div className=" relative ">
                <input
                  type="text"
                  value={step.title}
                  onChange={(e) => setStep({ ...step, title: e.target.value})}
                  className=" rounded-lg border-transparent flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 shadow-sm text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                  placeholder="Nom de l'étape"
                />
              </div>
            </div>
            <div>
              <div className=" relative ">
                <label className="text-gray-700" htmlFor="name">
                  <textarea
                    className="flex-1 appearance-none border border-gray-300 w-full py-2 px-4 bg-white text-gray-700 placeholder-gray-400 rounded-lg text-base focus:outline-none focus:ring-2 focus:ring-blue-600 focus:border-transparent"
                    placeholder="Vos commentaires"
                    rows="5"
                    cols="40"
                    value={step.desc}
                    onChange={(e) => setStep({ ...step, desc: e.target.value})}
                  />
                </label>
              </div>
            </div>
            <div>
              <div className=" relative ">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    className="h-6 w-6"
                    checked={closed}
                    onChange={(e) => setClosed(e.target.checked)}
                  />
                  <span className="ml-2">Clore le dossier</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <hr/>
        <div className="w-full px-4 pb-4 ml-auto text-gray-500 md:w-1/3">
          <LoadableButton title="Enregistrer" loading={loading} onClick={handleSave} />
        </div>
      </div>
    </form>
  );
}

export default HistoryForm
